// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseTabs_root__k-9Nj","primary":"BaseTabs_primary__3PsQ8","secondary":"BaseTabs_secondary__VjS9u","tab":"BaseTabs_tab__87xhQ","selected":"BaseTabs_selected__xbyRW"};